import React, { useState } from "react";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { Dropdown } from "primereact/dropdown";

export const SelectwithImage = () => {
  const options = [
    {
      label: "Darlee Robertson",
      value: "avatar-19.jpg",
      image: "assets/img/profiles/profile-img.jpg",
    },
    {
      label: "Sharon Roy",
      value: "avatar-20.jpg",
      image: "assets/img/profiles/profile-img.jpg",
    },
    {
      label: "Vaughan",
      value: "avatar-21.jpg",
      image: "assets/img/profiles/profile-img.jpg",
    },
    {
      label: "Jessica",
      value: "avatar-23.jpg",
      image: "assets/img/profiles/profile-img.jpg",
    },
    {
      label: "Carol Thomas",
      value: "avatar-16.jpg",
      image: "assets/img/profiles/profile-img.jpg",
    },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const customOptionTemplate = (option: any) => (
    <div className="p-clearfix">
      <ImageWithBasePath alt={option.label} src={option.image} />
      <span>{option.label}</span>
    </div>
  );

  const customValueTemplate = (option: any) => {
    if (!option) {
      return <span>{"Choose"}</span>;
    }
    return (
      <div className="p-clearfix">
        <ImageWithBasePath alt={option.label} src={option.image} />
        <span>{option.label}</span>
      </div>
    );
  };
  return (
    <div>
      <Dropdown
        value={selectedOption}
        options={options}
        optionLabel="label"
        optionValue="value"
        itemTemplate={customOptionTemplate}
        valueTemplate={customValueTemplate}
        onChange={(e) => setSelectedOption(e.value)}
        style={{ width: "100%" }}
        placeholder="Choose"
      />
    </div>
  );
};
